import {
  EXAM_ADD_NEW,
  EXAM_STATUS,
  EXAM_SET_PROFILE,
  EXAM_REMOVE_LOADING,
  EXAM_UPDATE_NEW,
  EXAM_SET_EDITING,
  EXAM_SET_FINISH_EDITING,
  EXAM_DELETE_NEW,
  EXAM_CLEAR_NEW_DATA,
  EXAM_ADD_MOST_SENT,
  EXAM_DELETE_EXAM_BY_ID,
  EXAM_REMOVE_PROFILE_BY_ID,
  EXAM_PROFILE_LIST
} from '../types'
import notify from '@/api/notification'
import strings from '../../strings'
import analytics from '@/api/analytics'
import examService from '@/api/exam'

const state = {
  newExams: [],
  mostSent: null,
  examModalAlert: false,
  status: 'STATUS_INITIAL',
  isExamProfile: false,
  examProfileList: []
}

const mutations = {
  [EXAM_ADD_NEW] (state, exam) {
    if (exam.type === 'LOADING') {
      state.newExams.unshift(exam)
    } else {
      for (let i = state.newExams.length - 1; i >= 0; i--) {
        if (state.newExams[i].type === 'LOADING' && (state.newExams[i].id === exam.id || state.newExams[i].id === exam.details.code)) {
          state.newExams.splice(i, 1)
          state.newExams.splice(i, 0, exam)
          break
        }
      }
    }
  },
  [EXAM_REMOVE_LOADING] (state, id) {
    for (let i = state.newExams.length - 1; i >= 0; i--) {
      if (state.newExams[i].type === 'LOADING' && state.newExams[i].id === id) {
        state.newExams.splice(i, 1)
        break
      }
    }
  },
  [EXAM_UPDATE_NEW] (state, exam) {
    let index = state.newExams.indexOf(exam.raw)

    let examState = state.newExams[index]
    examState.sample.material = exam.material
    examState.sample.amount = exam.amount
    examState.notes = exam.notes
    examState.urgent = exam.urgent
    examState.additional_field_values = exam.additionalFieldValues
    examState.code_origin_lis = exam.code_origin_lis
    // Curve exams
    if (exam.collectTimes) {
      examState.sample.collectTimes.splice(0)
      examState.sample.collectTimes.push(...exam.collectTimes)
    }
    // Paternity exams
    if (exam.paternity_participants) {
      examState.collector_name = exam.collector_name
      examState.judge_name = exam.judge_name
      exam.paternity_participants.forEach(element => {
        element.gender = element.genderCombo.value
        element.relationship = element.relationshipCombo.value
      })
      examState.paternity_participants = exam.paternity_participants
    }
  },
  [EXAM_SET_FINISH_EDITING] (state, exam) {
    let index = state.newExams.indexOf(exam)
    let examState = state.newExams[index]
    if (examState) examState.editing = false
  },
  [EXAM_SET_EDITING] (state, exam) {
    let index = state.newExams.indexOf(exam)
    let examState = state.newExams[index]
    if (examState) examState.editing = true
  },
  [EXAM_SET_PROFILE] (state, isExamProfile) {
    state.isExamProfile = isExamProfile
  },
  [EXAM_DELETE_NEW] (state, exam) {
    let index = state.newExams.indexOf(exam)
    state.newExams.splice(index, 1)
  },
  [EXAM_DELETE_EXAM_BY_ID] (state, id) {
    state.newExams = state.newExams.filter((obj) => {
      return obj.id !== id
    })
  },
  [EXAM_REMOVE_PROFILE_BY_ID] (state, id) {
    state.examProfileList = state.examProfileList.filter((obj) => {
      return obj.id_profile !== id
    })
  },
  [EXAM_CLEAR_NEW_DATA] (state) {
    state.newExams = []
    state.examProfileList = []
  },
  [EXAM_ADD_MOST_SENT] (state, mostSentExams) {
    state.mostSent = mostSentExams
  },
  [EXAM_STATUS] (state, status) {
    state.status = status
  },
  [EXAM_PROFILE_LIST] (state, list) {
    state.examProfileList = state.examProfileList.concat(list)
  }
}

const getters = {
  newExamsList: state => {
    return state.newExams
  },
  examProfileList: state => {
    return state.examProfileList
  },
  examIsLoading: state => {
    return state.status === 'LOADING'
  },
  examModalAlert: state => {
    return state.examModalAlert
  },
  isAllNewExamsFilled: state => {
    if (state.newExams.length === 0) {
      return false
    }
    for (let i = 0; i < state.newExams.length; i++) {
      if (state.newExams[i].editing) {
        return false
      }
    }
    return true
  },
  isExamProfile: state => {
    return state.isExamProfile
  }
}

const actions = {
  examProfileListSet ({commit}, list) {
    commit(EXAM_PROFILE_LIST, list)
  },
  examIsProfile: ({commit}, input) => {
    commit(EXAM_SET_PROFILE, input)
  },
  searchExam: function ({ state }, obj) {
    return new Promise((resolve, reject) => {
      let examList = { value: null }

      if (obj.showDefaultList) {
        examList.value = state.mostSent
        resolve(examList)
      } else if (obj.query.length === 1 || !obj.query || obj.query.match('(  )')) {
        resolve(examList)
      } else {
        return examService
          .search(obj.query)
          .then(response => {
            analytics.pushAnalyticsEvent('ga-event', { category: 'Cadastro Manual', action: 'Busca de exame' })
            if (response.data.value.length === 0) {
              examList.value = [
                {
                  code: null
                }
              ]
            } else {
              examList.value = response.data.value.map(e => {
                e.id = parseInt(e.id_exam)
                return e
              })
            }
            resolve(examList)
          })
          .catch(() => {
            return examService
              .searchAlternative(obj.query)
              .then(response => {
                if (response.data.length === 0) {
                  examList.value = [
                    {
                      code: null
                    }
                  ]
                } else {
                  examList.value = response.data.map(e => {
                    e.id = parseInt(e.id)
                    return e
                  })
                }
                resolve(examList)
              })
              .catch(() => {
                notify({
                  title: 'AVISO:',
                  message: 'Erro ao buscar exames. Por favor, tente novamente.'
                })
                resolve(examList)
              })
          })
      }
    })
  },
  getExamDetails ({ commit, dispatch }, id) {
    commit(EXAM_STATUS, 'LOADING')
    return examService
      .getExamDetailsById(id)
      .then(response => {
        let exam = response.data
        dispatch('checkExamAddRules', response.data)
          .then(() => {
            dispatch('createExam', exam).then(response => {
              commit(EXAM_STATUS, 'STATUS_INITIAL')
              commit(EXAM_ADD_NEW, response)
            })
          })
          .catch(response => {
            commit(EXAM_STATUS, 'STATUS_INITIAL')
            dispatch('removeLoadingExam', id)
            notify({
              title: response.title,
              message: response.message
            })
          })
      })
      .catch(error => {
        commit(EXAM_STATUS, 'STATUS_INITIAL')
        dispatch('removeLoadingExam', id)
        if (error.response.data.code === 'INVALID_RESTRICTION' || error.response.data.code === 'DISABLED') {
          notify({
            title: 'AVISO:',
            message: error.response.data.message
          })
        } else {
          notify({
            title: 'AVISO:',
            message: 'Erro ao obter as informações do exame. Por favor, tente novamente.'
          })
        }
      })
  },
  setProfileExam ({ commit, dispatch }, obj) {
    commit(EXAM_STATUS, 'LOADING')
    return examService
      .getExamDetailsById(obj.id)
      .then(response => {
        let exam = response.data
        dispatch('checkExamAddRules', response.data)
          .then(() => {
            exam.sample = {
              amount: 1,
              material: obj.material
            }
            exam.isFromProfile = true
            dispatch('createExam', exam).then(response => {
              commit(EXAM_STATUS, 'STATUS_INITIAL')
              commit(EXAM_ADD_NEW, response)
            })
          })
          .catch(response => {
            commit(EXAM_STATUS, 'STATUS_INITIAL')
            dispatch('removeLoadingExam', obj.id)
            notify({
              title: response.title,
              message: response.message
            })
          })
      })
      .catch(error => {
        commit(EXAM_STATUS, 'STATUS_INITIAL')
        dispatch('removeLoadingExam', obj.id)
        if (error.response.data.code === 'INVALID_RESTRICTION' || error.response.data.code === 'DISABLED') {
          notify({
            title: 'AVISO:',
            message: error.response.data.message
          })
        } else {
          notify({
            title: 'AVISO:',
            message: 'Erro ao obter as informações do exame. Por favor, tente novamente.'
          })
        }
      })
  },
  pushLoadingExam ({ commit }, id) {
    let exam = {
      id: id,
      type: 'LOADING',
      editing: true
    }
    commit(EXAM_ADD_NEW, exam)
  },
  removeLoadingExam ({ commit }, id) {
    commit(EXAM_REMOVE_LOADING, id)
  },
  sucessAddNewExam ({ commit }, exam) {
    commit(EXAM_SET_FINISH_EDITING, exam)
  },
  deleteOrderExams ({ commit }, index) {
    commit(EXAM_DELETE_NEW, index)
  },
  deleteOrderExamsById ({ commit }, id) {
    commit(EXAM_DELETE_EXAM_BY_ID, id)
  },
  orderRemoveProfile ({ commit }, id) {
    commit(EXAM_REMOVE_PROFILE_BY_ID, id)
  },
  openExamCard: function ({ commit }, exam) {
    if (exam && exam.editing !== true) {
      commit(EXAM_SET_EDITING, exam)
    }
  },
  checkExamAddRules: function ({ state }, data) {
    return new Promise((resolve, reject) => {
      if (data.type === 'PATERNITY' && state.newExams.filter(item => item.type !== 'LOADING').length > 0) {
        reject(strings.searchAddExamMessages.insertPaternityInNotEmptyOS)
      }
      if (data.type === 'PATERNITY' && state.isExamProfile) {
        reject(strings.searchAddExamMessages.insertPaternityOnProfile)
      }
      if (state.newExams.filter(item => item.type === 'PATERNITY').length) {
        reject(strings.searchAddExamMessages.hasAlreadyPaternity)
      }
      if (state.isExamProfile && state.newExams.filter(item => item.id === data.id).length > 1) {
        reject(strings.searchAddExamMessages.examDuplicatedNotAllowed)
      }
      resolve(true)
    })
  },
  createExam: function ({ state }, examDetailsResponse) {
    let defaultMaterial
    if (examDetailsResponse.materials) {
      defaultMaterial = examDetailsResponse.materials.find(element => {
        return element.default
      })
    }
    let examData = {
      editing: true,
      id: examDetailsResponse.id,
      examOrigin: examDetailsResponse.recollect ? 'R' : 'M',
      type: examDetailsResponse.type,
      notes: examDetailsResponse.notes ? examDetailsResponse.notes : '',
      sample: {
        amount: examDetailsResponse.sample ? examDetailsResponse.sample.amount : 1,
        material: examDetailsResponse.sample ? examDetailsResponse.sample.material : defaultMaterial ? defaultMaterial.id : null,
        collectTimes: []
      },
      additional_field_values: [],
      urgent: examDetailsResponse.urgent
    }
    examData.details = examDetailsResponse

    // Add to the exam an unique identifier that will be used as "key" when
    // rendering each exam component
    // (this identifier need to be unique among all the exams added to the order.
    // For this reason, the field "id" cannot be used, since the user can add
    // the same exam several times)
    examData.componentUniqUid = generateUID()

    // Populate the attribute used for editing an order (track the exam selected
    // by the user)
    if (examDetailsResponse.id_exam_order) {
      examData.id_exam_order = examDetailsResponse.id_exam_order
    }
    if (examDetailsResponse.code_origin_lis) {
      examData.code_origin_lis = examDetailsResponse.code_origin_lis
    }
    // Initialize the additional_field_values array with null values ou or value if defined
    if (examDetailsResponse.fields && examDetailsResponse.fields.length > 0) {
      for (let i = 0; i < examDetailsResponse.fields.length; i++) {
        let field = examDetailsResponse.fields[i]
        examData.additional_field_values.push({
          id: field.id,
          value: field.value
        })
      }
    }

    return examData
  },
  getMostSentExam: function ({ commit, state }) {
    if (state.mostSent == null) {
      examService.getMostSentExams().then(response => {
        if (response.status === 200) {
          commit(EXAM_ADD_MOST_SENT, response.data)
        }
      })
    }
  },
  clearExamList: function ({ commit }) {
    commit(EXAM_CLEAR_NEW_DATA)
  }
}

let generateUID = function () {
  let firstPart = (Math.random() * 46656) | 0
  let secondPart = (Math.random() * 46656) | 0
  firstPart = ('000' + firstPart.toString(36)).slice(-3)
  secondPart = ('000' + secondPart.toString(36)).slice(-3)
  return firstPart + secondPart
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
